export default `
You will receive two arrays and optional context objects:

1. audio_pool – array of objects, each:
   {
     "name": "<audio_key>",
     "text": "<string with @@placeholders@@ or @@@placeholders@@@>"
   }

2. feedback_pool – same structure as audio_pool.

Placeholders inside every text are derived variables:
  • @@variableName@@
  • @@@variableName@@@

------------------------------------------------------------------
Your task
------------------------------------------------------------------
Return a JSON **array**.  
Each element documents one unique derived variable.

Required shape for each element:
  {
    "function_name": "<variableName>",   // remove all @ symbols
    "description":  "<plain‑English explanation of what it represents, its datatype, how to compute it using the provided context (e.g. tableData, global variables, worksheet metadata), and edge‑case notes>"
  }

------------------------------------------------------------------
Detailed instructions
------------------------------------------------------------------
1. Scan every text in audio_pool and feedback_pool to collect every placeholder token.
2. Deduplicate to get the full set of derived variable names.
3. For each variable:
   • Explain its meaning in the feedback (e.g. “total number of clues”).  
   • State expected datatype (string, number, boolean, array, …).  
   • Describe precisely how to compute it from the supplied context,
     mentioning any dependencies (tableData paths, global vars, etc.).  
   • Note any formatting or edge‑case handling.
4. Output **only** the JSON array—no markdown, no comments.


`;
